import { ArrowType } from '../panorama/enums';
import { isPolygonalArrow, isSimpleArrow } from '../panorama/arrows/arrowTypeguards';
export const convertArrowFromServerModel = (serverModel) => ({ ...serverModel });
export const convertArrowToServerModel = (arrow) => {
    if (isSimpleArrow(arrow)) {
        return {
            arrowText: arrow.arrowText,
            arrowPositionConfiguration: {
                arrowPosition: arrow.arrowPositionConfiguration.arrowPosition,
                arrowPositionType: ArrowType.Simple,
            },
            sceneIndex: arrow.sceneIndex,
            tourSceneGuid: arrow.tourSceneGuid,
            fov: arrow.fov,
        };
    }
    if (isPolygonalArrow(arrow)) {
        return {
            arrowPositionConfiguration: {
                arrowPosition: arrow.arrowPositionConfiguration.arrowPosition,
                arrowPositionType: ArrowType.Polygon,
            },
            sceneIndex: arrow.sceneIndex,
            tourSceneGuid: arrow.tourSceneGuid,
            fov: arrow.fov,
        };
    }
    throw Error('Unknown arrow model.');
};
